import React, { useState, useEffect } from 'react';

function NotificationHistory({ history }) {
  const [tickerFilter, setTickerFilter] = useState('');
  const [filteredHistory, setFilteredHistory] = useState([]);

  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    // Convert to Eastern time
    return date.toLocaleTimeString('en-US', { 
      timeZone: 'America/New_York',
      hour: 'numeric',
      minute: '2-digit',
      second: '2-digit',
      hour12: true
    });
  };

  useEffect(() => {
    // Filter history based on ticker
    let filtered = history;
    if (tickerFilter) {
      filtered = history.filter(notification => 
        notification.ticker && 
        notification.ticker.toUpperCase().includes(tickerFilter.toUpperCase())
      );
    }
    // Show last 20 notifications
    setFilteredHistory(filtered.slice(-20).reverse());
  }, [history, tickerFilter]);

  const handleClearFilter = () => {
    setTickerFilter('');
  };

  return (
    <div className="dashboard-card half-width">
      <h2>Recent Notifications</h2>
      <div style={{ marginBottom: '10px' }}>
        <input
          type="text"
          placeholder="Filter by ticker..."
          value={tickerFilter}
          onChange={(e) => setTickerFilter(e.target.value)}
          style={{
            padding: '8px 12px',
            width: '100%',
            maxWidth: '300px',
            border: '1px solid var(--border-color)',
            borderRadius: '4px',
            fontSize: '14px',
            backgroundColor: 'var(--bg-secondary)',
            color: 'var(--text-primary)'
          }}
        />
        {tickerFilter && (
          <button
            onClick={handleClearFilter}
            style={{
              marginLeft: '8px',
              padding: '8px 12px',
              backgroundColor: 'var(--danger)',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '14px'
            }}
          >
            Clear
          </button>
        )}
      </div>
      <div className="notification-list">
        {filteredHistory.map((notification, index) => (
          <div key={index} className="notification-item" style={{ width: '100%' }}>
            <div className="notification-time">
              {formatTime(notification.timestamp)}
            </div>
            <div style={{ marginTop: '4px' }}>
              <strong>{notification.ticker}</strong> → User {notification.user_id}
            </div>
            <div style={{ 
              fontSize: '0.875rem', 
              marginTop: '4px', 
              color: 'var(--text-secondary)',
              wordWrap: 'break-word',
              whiteSpace: 'pre-wrap',
              overflowWrap: 'break-word',
              width: '100%'
            }}>
              {notification.message}
            </div>
          </div>
        ))}
        {filteredHistory.length === 0 && (
          <div style={{ textAlign: 'center', padding: '20px', color: 'var(--text-secondary)' }}>
            No recent notifications
          </div>
        )}
      </div>
    </div>
  );
}

export default NotificationHistory;